import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEn from "./translation/translation-en.json";
import translationJa from "./translation/translation-ja.json";
import translationSe from "./translation/translation-se.json";

const resources = {
    en: translationEn,
    ja: translationJa,
    se: translationSe
};

i18n
    .use(initReactI18next)
    .init({
        lng: "en",
        fallbackLng: "ja",
        resources
    });
export default i18n;